export function thinHmaTurningMovements(project) {
  if (
    (project.twoWayTurnPresent === 1 ||
      project.twoWayTurnPresent === -1) && project.intersectionPresent === 1
  ) {
    return {
      title: "Turning Movements",
      message:
        "You indicated the presence of two-way left turn lane(s) in your segment.  Consider using a 3/8-inch asphalt overlay at the intersection of aterials and collectors, and at intersections subject to regular heavy vehicles (e.g. buses, dump trucks) turning movements."
    };
  }
}

export function thinHmaGeosynthetics(project) {
  if (project.hasGeotextiles === 1) {
    return {
      title: "Geosynthetics",
      message:
        "You indicated the presence of geosynthetic materials, the use of which risks trapping moisture in the pavement. Overall, geosynthetics are not recommended as the risks generally outweight potential benefits. Geosynthetics are intended to control reflective cracking propagating from the existing pavement to the overlay and may also act as a moisture barrier. However, Geosynthetics are not effective in reducing reflection of thermal cracks, in areas of heavy rainfall, or in areas with significant freeze-thaw cycles."
    };
  }
}

export function thinHmaCurb(project) {
  if (project.hasCurb) {
    return {
      title: "Curb to Match",
      message: "You have indicated presence of a curb to match. RxPave recommends that you integrate this constraint in your resulting pavement design."
    };
  }
}

export function thinHmaAC1(project, chipCapeScore, thinHmaScore) {
  if (chipCapeScore === thinHmaScore || project.requireMaintainCurbReveal === 2) {
    return {
      title: "Additional Considerations",
      message:
        "HMA Overlay is a viable treatment option. Consider a 1-inch thick 9.5 or 4.75 mm NMAS HMA overlay"
    };
  }
}

/* Redundant, deprecated */
// export function thinHmaAC2(project, chipCapeScore, thinHmaScore) {
//   if (chipCapeScore !== thinHmaScore || project.requireMaintainCurbReveal === 1) {
//     return {
//       title: "Additional Considerations",
//       message:
//         "HMA Overlay is a viable treatment option."
//     };
//
// }

export function thinHmaAC3(project, chipCapeScore, thinHmaScore) {
  if (project.requireMaintainCurbReveal === -1) {
    return {
      title: "Additional Considerations",
      message:
        "HMA Overlay is a viable treatment option, but you have indicated uncertainty for some inputs. If your resulting pavement must maintain curb reveal, consider a 1-inch thick 9.5 or 4.75 mm NMAS HMA overlay."
    };
  } else if (project.requireMaintainCurbReveal === 1){
    return {
       title: "Additional Considerations",
      message:
        "If your resulting pavement must maintain curb reveal, consider a 1-inch thick 9.5 or 4.75 mm NMAS HMA overlay."   }
  }
}




